import settingsModule from '../../settings.module';
import template from './accountAuthentication.component.html';
import style from './accountAuthentication.component.css';

export default settingsModule.component('accountAuthentication', {
    template,
    style,
    controller(__env) {
        const vm = this;
        var accountAuthenticationURL = new URL("/signin/#!/login?returnUrl=%2Fconsole%2F%23!%2Fusers%2Fsettings%2Faccountauthentication", __env.cloudUrl);
        vm.accountAuthenticationUrl = accountAuthenticationURL.toString();
    }
});



// WEBPACK FOOTER //
// ./modules/settings/components/accountAuthentication/accountAuthentication.component.js